import React, { useEffect, useState } from "react";
import Modal from "../../../../components/Modal";
import { Context } from "../../../../config/store";
import { objectsForEach } from "../../../../common/objectToArray";
import splitUnderscoreToCaptialise from "../../../../common/splitUnderscoreToCaptialise";
import LenderUgroService from "../../../../services/lender";
import { toast } from "react-toastify";

let modLength = 0;

const AdditionalInfoTRNCH = ({
  modalState,
  toggleModal,
  onChange,
  params,
  keyName,
  selectedLender,
  leadId,
  body,
}) => {
  //console.log("params", params);
  const skeleton = params.find(({ id }) => id == keyName);
  const { title, type, trnch_iteration, ...config } = skeleton?.trnch_data;
  const [modalDataLength, setModalDataLength] = useState(0);
  
  const getTrnchDataArray = (num) => {
    let data = [];
    Object.keys(skeleton?.trnch_data).map((item) => {
      if (item !== "title" && item !== "type" && item !== "trnch_iteration") {
        data.push({
          [item]: "",
        });
      }
    });
    modLength = data?.length;
    let newData = data.reduce((prev, curr) => ({ ...prev, ...curr }), {});
    const finalArray = Array.from(
      {
        length: num,
      },
      () => newData
    );
    return finalArray;
  };
  const { state } = React.useContext(Context);
  const [loading, setLoading] = React.useState(false);
  const [trnchData, setTrnchData] = React.useState(
    getTrnchDataArray(body?.loan_details?.NumberOfTranche)
  );
  const [key, setKey] = React.useState(Math.random());
  const [errors, setErrors] = React.useState([]);
  const [modalDataId, setModalDataId] = React.useState(skeleton?.id);

  const tempDate = new Date().toISOString().split("T")[0].split("-");
  const maxDate = `${tempDate[0]}-${tempDate[1]}`;

  const checkHasPermission = (checkPermission) => {
    if (state.is_super_admin === 1) return true;
    const permission = state.permission.find(
      (permission) => permission === checkPermission
    );

    if (permission) return true;
    else return false;
  };

  useEffect(() => {
    setTrnchData(getTrnchDataArray(body?.loan_details?.NumberOfTranche));
  }, [body?.loan_details?.NumberOfTranche]);


  useEffect(() => {
    setModalDataLength(modLength);
    getAdditionalInformationAbbData();
  }, [modalDataId]);
  const getAdditionalInformationAbbData = async () => {
    let response = await LenderUgroService.getAdditionalInfoTranchData({
      type: state.userType,
      add_info_trnch_id: (body?.loan_details?.[modalDataId] !== undefined || body?.loan_details?.[modalDataId] !== null) ? body?.loan_details?.[modalDataId] : "",
      leadId: leadId,
      cl_lender_id: selectedLender
    });
    response?.data?.data?.addInfoTrnch?.res_json?.length > 0 &&
    setTrnchData(response?.data?.data?.addInfoTrnch?.res_json);
    console.log("modalDataId - ",body?.loan_details?.[modalDataId]);
  };

  const handleAbbModalChange = (index, name, value) => {
    let data = trnchData;
    const newData = data.map((p, i) =>
      i === index ? { ...p, [name]: value } : p
    );
    setTrnchData(newData);
    setKey(Math.random());
  };

  const saveTRNCHData = async (e) => {
    e.preventDefault();
    let payloadData = {
      trnch_config_data: {
        ...skeleton?.trnch_data,
      },
      trnch_data: trnchData,
    };
    console.log("saveTRNCHData", payloadData);
    let response = await LenderUgroService.saveAdditionalInfoTranchData({
      type: state.userType,
      leadId: leadId,
      cl_lender_id: selectedLender,
      payloadData
    });
    if (response.data?.status?.code == 1) {
      let trnch_id = response?.data?.data?.add_info_trnch_id;
      onChange({ target: { value: trnch_id } });
      toast.success(
        response?.data?.messages?.success?.others[0] ||
        response?.data?.messages?.success?.form[0]
      );
      toggleModal();
    } else {
      setErrors(response?.data?.err_data?.trnch_data);
    }
  };

  const onClose = async () => {
    body?.loan_details?.[modalDataId] &&
      (await getAdditionalInformationAbbData());
    setErrors([]);
    toggleModal();
  };

  return (
    <>
    { body?.loan_details?.NumberOfTranche ? 
    <Modal
      state={modalState}
      closeModal={() => onClose()}
      removeBorderSpace={true}
      style={{
        width: 'fit-content',
        maxWidth: '90%'
      }}
    >
      <div className="card border-0">
        <div className="modal-header-container">
          <div className="modal-title">{skeleton.label}</div>
          <div className="closeModalView" onClick={() => onClose()}>
            <span className="closeModalIcon">x</span>
          </div>
        </div>
        <div className="px-4 pt-4 pb-3 modalData" style={{ maxHeight: "75vh" }}>
          <div className="row position-sticky">
            {objectsForEach(config).map((row, index) => (
              <div
                class={`col-md-${12 / modalDataLength}`}
                style={{ width: "150px", padding: "0px 5px" }}
              >
                <label
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: 'center',
                    textAlign: "center",
                    fontSize: "12x",
                  }}
                >
                  {row.label} {row.value == "1" && <tt>*</tt>}
                </label>
              </div>
            ))}
          </div>
          <form
            style={{
              maxHeight: "300px",
              overflowY: "scroll",
              overflowX: "clip",
              paddingLeft: "10px",
              paddingRight: "10px"
            }}
          >
            {trnchData?.map((val, index1) => {
              return (
                <div
                  class="row"
                  style={{
                    flexWrap: "nowrap",
                    overflowX: "auto",
                  }}
                >
                  {objectsForEach(config).map((row, index2) => (
                    <div
                      class={`col-md-${12 / modalDataLength}`}
                      style={{ width: "150px", padding: "0px 5px" }}
                    >
                        <>
                          <input
                            type={row?.rule?.input_type}
                            name={row.id}
                            className="form-control"
                            value={val?.[row.id]}
                            onChange={(e) =>
                              handleAbbModalChange(
                                index1,
                                row.id,
                                e.target.value
                              )
                            }
                          />
                          {
                            <p
                              className="text-danger"
                              style={{
                                fontSize: "10px",
                                paddingTop: "0px",
                              }}
                            >
                              {errors[index1]?.[row.id]}
                            </p>
                          }
                        </>
                    </div>
                  ))}
                </div>
              );
            })}
          </form>
          <div className="position-sticky col-lg-12 col-md-12 col-sm-12 col-12 text-center">
            {(state.userType === "admin"
              ? checkHasPermission("save-additional-info")
              : true) && (
                <div style={{ marginTop: "10px" }}>
                  <button
                    className="btn btn-custom btn-custom-height m-auto"
                    disabled={loading}
                    onClick={saveTRNCHData}
                  >
                    {loading ? <div className="loader"></div> : "Save"}
                  </button>
                </div>
              )}
          </div>
        </div>
      </div>
    </Modal>
    :
    <Modal
      state={modalState}
      closeModal={() => onClose()}
      removeBorderSpace={true}
      style={{
        width: 'fit-content',
        maxWidth: '90%'
      }}
    >
      <div className="card border-0">
        <div className="modal-header-container">
          <div className="modal-title">{skeleton.label}</div>
          <div className="closeModalView" onClick={() => onClose()}>
            <span className="closeModalIcon">x</span>
          </div>
        </div>
        <div className="position-sticky col-lg-12 col-md-12 col-sm-12 col-12 text-center">
            <div style={{ margin: "50px" }}>
              <p>Please Enter Number of Tranche.</p>
            </div>
        </div>
      </div>
    </Modal>
    }
    </>
  );
};

export default AdditionalInfoTRNCH;
